import { v4 as uuidv4 } from 'uuid';

import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { IKnmErknmFormJudgment } from '../interfaces/IKnmErknmFormJudgment';
import { createJudgmentKindSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentKindSelectOption';
import {
  getDistrictSelectOptions,
  getJudgmentCourtLevelSelectOptions,
} from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { createJudgmentCourtSelectOption } from '../../../CorePackage/CatalogsModule/common/createJudgmentCourtSelectOption';
import { IKnmErknmFormAct } from '../interfaces/IKnmErknmFormAct';
import { IKnmErknmFormResultDecision } from '../interfaces/IKnmErknmFormResultDecision';
import { IKnmErknmFormJudgmentCanceled } from '../interfaces/IKnmErknmFormJudgmentCanceled';
import { convertKnmJudgmentSubjectsDataToFormValues } from './convertKnmJudgmentSubjectsDataToFormValues';
import { convertInitialKnmDateToFormDate } from '../../../KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { DATE_FORMAT_LONG_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';

export const convertKnmDataJudgmentsToFormValues = (
  state: IRootState,
  judgments: IKnm248['judgments'] | undefined,
  formActs: IKnmErknmFormAct[] | undefined,
  formDecisions: IKnmErknmFormResultDecision[] | undefined,
): IKnmErknmForm['judgments'] => {
  return judgments?.map(item => {
    const formJudgment: IKnmErknmFormJudgment = {
      ...item,
      guid: item.guid || undefined,
      dateJudgment: convertInitialKnmDateToFormDate(item.dateJudgment, DATE_FORMAT_LONG_FNS) || undefined,
      numberJudgment: item.numberJudgment || undefined,
      attachment: item.attachment || undefined,
      kindJudgment: item.kindJudgment ? createJudgmentKindSelectOption(item.kindJudgment) : undefined,
      rfRegionCode: item.court?.rfRegion
        ? getDistrictSelectOptions(state).find(x => x.code === `0${item.court?.rfRegion}`)
        : undefined,
      courtLevelCode: item.court?.courtType
        ? getJudgmentCourtLevelSelectOptions(state).find(x => x.code === item.court?.courtType)
        : undefined,
      court: item.court ? createJudgmentCourtSelectOption(item.court) : undefined,
      judgmentAction: item.judgmentAction || undefined,
      judgmentSubjectData: item.judgmentSubjectData
        ? convertKnmJudgmentSubjectsDataToFormValues(item.judgmentSubjectData, formActs, formDecisions)
        : undefined,
      canceledJudgments:
        item.canceledJudgments?.map(canceledJudgment => {
          const formCanceledJudgment: IKnmErknmFormJudgmentCanceled = {
            ...canceledJudgment,
            guid: canceledJudgment.guid || undefined,
            numberJudgment: judgments?.find(x => x.guid === canceledJudgment.guid)?.numberJudgment || undefined,
            judgmentSubjectData: canceledJudgment.judgmentSubjectData
              ? convertKnmJudgmentSubjectsDataToFormValues(
                  canceledJudgment.judgmentSubjectData,
                  formActs,
                  formDecisions,
                )
              : undefined,
            listId: uuidv4(),
          };

          return formCanceledJudgment;
        }) || undefined,
      createNewJudgment: item.canceledJudgments && item.judgmentSubjectData ? true : undefined,
      listId: item.guid || uuidv4(),
      isNew: !!item.isNew,
    };

    return formJudgment;
  });
};
